import { all, fork } from "redux-saga/effects";

import accountsSaga from "actions/accounts.jsx";
import userSaga from "actions/users.jsx";
import invitationsSaga from "actions/invitations.jsx";
import streamsSaga from "actions/streams";
import collectionsSaga from "actions/collections";
import assetsSaga from "actions/assets";
import sharesSaga from "actions/shares";
import reportsSaga from "actions/reports";
import userGroupsSaga from "actions/userGroups";
import iadbMetadataSaga from "actions/iadb";
import cleverstoryWorkspaceSaga from "actions/cleverstory";
import auditLogsSaga from "actions/auditLogs";
import adoptionMetricsSaga from "actions/adoptionMetrics";
import downloadsSaga from "actions/downloads";
import datasourceSaga from "actions/datasource";
import fetchColorCustomization from "actions/color";
import seekLimitSaga from "actions/seek";
import  updateContractTerm  from "actions/contract";
import customerDetailSaga from "actions/downloadInvoice";
import generateReportSaga from "actions/generateReport";
import dataSourceSagaInspector from 'actions/dataSourceInspector';
import accountAssetTransactionSaga from "actions/assetManagement";
import accountMetricsSaga from "actions/metrics";


export default function* root() {
  yield all([
    fork(accountsSaga),
    fork(userSaga),
    fork(invitationsSaga),
    fork(streamsSaga),
    fork(collectionsSaga),
    fork(assetsSaga),
    fork(sharesSaga),
    fork(reportsSaga),
    fork(userGroupsSaga),
    fork(iadbMetadataSaga),
    fork(cleverstoryWorkspaceSaga),
    fork(auditLogsSaga),
    fork(adoptionMetricsSaga),
    fork(downloadsSaga),
    fork(datasourceSaga),
    fork(fetchColorCustomization),
    fork(seekLimitSaga),
    fork(updateContractTerm),
    fork(customerDetailSaga),
    fork(generateReportSaga),
    fork(dataSourceSagaInspector),
    fork(accountAssetTransactionSaga),
    fork(accountMetricsSaga)
  ]);
}